import { createSlice } from '@reduxjs/toolkit';
import {
  fetchCarHouseInvoices,
  payCarHouseInvoices,
  fetchCarHouseInvoicesItems,
  fetchUserInvoices,
  payUserInvoices,
  fetchUserInvoicesItems,
} from '../actions/invoices-actions';

const initialState = {
  invoicesLoading: false,
  itemsLoading: false,
  invoices: [],
  invoiceItems: [],
  error: null,
};

const invoicesSlice = createSlice({
  name: 'invoices',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    // ** CarHouse Invoices **

    builder
      .addCase(fetchCarHouseInvoices.fulfilled, (state, action) => {
        state.invoices = action.payload;
      })
      .addCase(payCarHouseInvoices.fulfilled, (state, action) => {
        const updatedInvoice = action.payload;
        state.invoices.previousInvoices.unshift(updatedInvoice);
      })
      .addCase(fetchCarHouseInvoicesItems.fulfilled, (state, action) => {
        state.invoiceItems = action.payload;
      });

    // ** User Invoices **

    builder
      .addCase(fetchUserInvoices.fulfilled, (state, action) => {
        state.invoices = action.payload;
      })
      .addCase(payUserInvoices.fulfilled, (state, action) => {
        const updatedInvoice = action.payload;
        state.invoices.previousInvoices.unshift(updatedInvoice);
      })
      .addCase(fetchUserInvoicesItems.fulfilled, (state, action) => {
        state.itemsLoading = true;
        state.invoiceItems = action.payload;
      });

    // ** Loading and Error handling for Invoices and Items **

    builder
      // ** Invoices **
      .addMatcher(
        (action) =>
          action.type.endsWith('/fetchCarHouseInvoices/pending') ||
          action.type.endsWith('/fetchUserInvoices/pending'),
        (state) => {
          state.invoicesLoading = true;
          state.error = null;
        }
      )
      .addMatcher(
        (action) =>
          action.type.endsWith('/fetchCarHouseInvoices/fulfilled') ||
          action.type.endsWith('/fetchUserInvoices/fulfilled'),
        (state) => {
          state.invoicesLoading = false;
          state.error = null;
        }
      )
      .addMatcher(
        (action) =>
          action.type.endsWith('/fetchCarHouseInvoices/rejected') ||
          action.type.endsWith('/fetchUserInvoices/rejected'),
        (state, action) => {
          state.invoicesLoading = false;
          state.error = action.error.message;
        }
      )

      // ** Items **

      .addMatcher(
        (action) =>
          action.type.endsWith('/fetchCarHouseInvoicesItems/pending') ||
          action.type.endsWith('/fetchUserInvoicesItems/pending'),
        (state) => {
          state.itemsLoading = true;
          state.error = null;
        }
      )
      .addMatcher(
        (action) =>
          action.type.endsWith('/fetchCarHouseInvoicesItems/fulfilled') ||
          action.type.endsWith('/fetchUserInvoicesItems/fulfilled'),
        (state) => {
          state.itemsLoading = false;
          state.error = null;
        }
      )
      .addMatcher(
        (action) =>
          action.type.endsWith('/fetchCarHouseInvoicesItems/rejected') ||
          action.type.endsWith('/fetchUserInvoicesItems/rejected'),
        (state, action) => {
          state.itemsLoading = false;
          state.error = action.error.message;
        }
      );
  },
});

export const invoicesActions = invoicesSlice.actions;

export default invoicesSlice;
